// extracted by mini-css-extract-plugin
module.exports = {"slider":"Carousel_slider__kB5fd","slider__block":"Carousel_slider__block__or1_T","slider__blockCentered":"Carousel_slider__blockCentered__yLM3U"};